import React from "react";

function NotFound() {
  return (
    <div className="mainContainerOuter">
      <div className="mainContainer">
        <div className="soonestAvailableContainer duration_full">
          <div className="timeslots">
            <div className="blockInner">Page Not found</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
